import RetainerPricingComponent from "../components/shop/retainer/retainerPricingComponent";
import NavigationBar from "../components/navigationBar";
import ShopComponent from "../components/shop/shopComponent";
import FooterView from "../components/footerView";
import {CartContext} from "./shop";


export default function PricingRetainer() {

    return (
        <div>
            <NavigationBar shouldHidePromotionalBanner={true} />
            <RetainerPricingComponent />
            <FooterView />
        </div>
    )
}